/**
 * @author m.mahdi_rasouli<rasoulimohammadmahdi@yahoo.com>
 * write all global configs in this file and import it where ever you need. This file is created in order to simplify
 * later config changes.
 */
let hostname = window.location.hostname
let protocol = window.location.protocol
//export const SERVER_URL = 'http://localhost:8080/';
export const SERVER_URL = protocol+'//panel.mci.sajayanegar.ir/api';
export const MCI_URL = protocol+'//panel.mci.sajayanegar.ir';
export const AXIOS_TIMEOUT = 10000;

